<template>
  <div>
    <transition name="pop-w-animate">
      <div class="pop-w" v-if="showAddPopW" @click="$emit('close-pop')"></div>
    </transition>
    <div class="pop">
      <transition name="pop-card">
        <div class="project-pop-card" v-if="showAddPop">
          <div class="title-w">
            <div class="title">{{ popTitle }}</div>
            <div class="close-pop"><i class="el-icon-close" @click="$emit('close-pop')"></i></div>
          </div>
          <div class="question"> {{ popDescription }} </div>
          <!-- <el-alert
            v-if="submitError"
            :title="submitError"
            type="error">
          </el-alert> -->
          <div style="text-align: center; margin-top: 16px">
            <el-button size="large" type="primary" round @click="$emit('primary-func')" style="margin-top: 16px; margin-bottom: 12px; margin-right: 12px;">{{ primaryButtonText }}</el-button>
            <el-button size="large" :type="secondaryButtonType" plain round @click="$emit('secondary-func')" style="margin-top: 16px; margin-bottom: 12px;">{{ plainButtonText }}</el-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopWindow',
  props: ['popTitle', 'popDescription', 'primaryButtonText', 'plainButtonText', 'showAddPopW', 'showAddPop', 'secondaryButtonType'],
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.pop-w-animate-enter-active {
  transition: all 0.2s ease;
}
.pop-w-animate-leave-active {
  transition: all 0.2s ease;
}
.pop-w-animate-enter, .pop-w-animate-leave-to {
  opacity: 0;
}
.pop-card-enter-active {
  transition: all 0.2s ease;
}
.pop-card-leave-active {
  transition: all 0.2s ease;
}
.pop-card-enter, .pop-card-leave-to {
  opacity: 0;
  width: 200px;
  height: 200px;
  margin: auto;
  border-radius: 50%;
  background-color: #ffffff;
  color: #ffffff !important;
  overflow: hidden;
}

.pop-w {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1999;
  background-color: rgba(0, 0, 0, 0.5);
}
.pop {
  position: fixed;
  top: 15vh;
  left: 25vw;
  z-index: 2000;
  width: 50vw;
  margin: 0 auto 2vh auto;
  color: #333;
}

.project-pop-card {
  border-radius: 20px;
  box-sizing: border-box;
  padding: 24px;
  background-color: #ffffff;
}

.title-w {
  display: flex;
  justify-content: space-between;
}
.title {
  font-size: 24px;
  line-height: 48px;
  font-weight: 600;
  margin-bottom: 20px;
}
.close-pop {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  padding: 15.5px;
  float: right;
  cursor: pointer;
}
.question {
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 12px;
  font-weight: 600;
}
.input-error {
  color: #f31431;
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px
}

@media screen and (max-width: 991px) {
  .pop {
    width: 75vw;
    left: 12.5vw;
  }
}

@media screen and (max-width: 500px) {
  .pop {
    width: 90vw;
    left: 5vw;
  }
}
</style>
